"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSubSection = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const GenericConfigSection_1 = require("./GenericConfigSection");
const ConfigSubSection = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    return (react_1.default.createElement(GenericConfigSection_1.GenericConfigSection, Object.assign({}, props, { kind: "sub-section" }), children));
};
exports.ConfigSubSection = ConfigSubSection;
//# sourceMappingURL=ConfigSubSection.js.map